import Button from "../buttons/Button";
import Services from '../../services/services';
import { useState, useContext, useEffect } from 'react';
import { ModalContext, LoadingContext } from "../../context/contextProvider";
import { ThemeColorsEnum } from "../../constants/enums";
import RenderFileContent from "../RenderFileContent";
import { useFormikContext } from "formik";
import FormFieldContainer from "./FormFieldContainer";
import FormFileInputField from "./FormFileInputField";
import { Col, Row } from "react-bootstrap";
import Constants from "../../constants/constants";

const getExtension = (fileName) => {
  if (fileName)
    return fileName.split(".").pop();
}

const FormFileInputAndDisplay = ({
  name,
  filePathId,
  onFileClear = () => { },
  onlyRender = false, // don't show the form part, just display
  acceptedTypes = Constants.defaultAcceptedFileTypes,
  ...otherProps
}) => {

  const formik = useFormikContext();
  const { setFieldTouched, setFieldValue } = !onlyRender ? formik : (() => { }, () => { });

  const { showBottomSheet, closeModal } = useContext(ModalContext);
  const [fileContent, setFileContent] = useState(null);
  const [rawFile, setRawFile] = useState(null);
  const { loading, setLoading } = useContext(LoadingContext);

  useEffect(() => {
    const loadFile = async () => {
      try {
        setLoading(true);
        if (rawFile) { // loading file from system
          if (rawFile === -1) {
            setFileContent(null);
          }
          //format rawFile into fileContent
          var fileData = rawFile;
          var fileMetaData = { displayName: rawFile?.name, fileName: null };
          var extension = getExtension(rawFile?.name);

          setFileContent({ fileData, fileMetaData, extension });
        }
        else if (filePathId) {
          const metaData = await Services.api.fileStorage.getFileMetadata(filePathId);
          if (!metaData?.ok) {
            console.log(metaData);
            return Services.utility.toast("Error: ", metaData.problem);
          }
          const fileData = await Services.api.fileStorage.getFile(filePathId);

          if (fileData && fileData?.ok) {
            const extension = getExtension(metaData?.data?.displayName);
            setFileContent({ fileData, metaData, extension });
          }
          else {
            console.error("got bad response from server: ", fileData);
            return Services.utility.toast("Problem retrieving file");
          }
        }
      } catch (error) {
        console.error("Error loading file:", error);
      } finally {
        setLoading(false);
      }
    };

    loadFile();
  }, [filePathId, rawFile]);

  const handleFileSelected = (file) => {
    setRawFile(file);
  };

  const handleRemoveFile = async () => {
    setRawFile(-1);
    setFieldValue(name, -1, false);
    document.getElementById("fileInput").value = "";
    setFieldValue("filePathId", "", false);
  };

  return (
    <Row>
      {!onlyRender && (
        <Col>
          <FormFieldContainer>
            <FormFileInputField
              label="Select a File"
              name="file"
              onFileSelect={handleFileSelected}
              acceptedTypes={acceptedTypes}
            />
            {(!!filePathId || !!rawFile) && (
              <Button
                title="Clear Files"
                onClick={handleRemoveFile}
              />
            )}

          </FormFieldContainer>
        </Col>
      )}
      <Col>
        {(!!filePathId || !!fileContent) && (loading ? (
          <p>Loading...</p>
        ) : (
          <div>
            <h4 className="ws-nowrap" style={{ fontWeight: 'bold' }}> Current File: </h4>
            <RenderFileContent withButton={false} clickable={true} fileContent={fileContent} />
          </div>
        ))}
      </Col>
    </Row>
  );
};


export default FormFileInputAndDisplay;
